import { render } from "./CharTab.vue?vue&type=template&id=d56aee36"
import script from "./CharTab.vue?vue&type=script&lang=js"
export * from "./CharTab.vue?vue&type=script&lang=js"

import "./CharTab.vue?vue&type=style&index=0&id=d56aee36&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__